import { render, staticRenderFns } from "./SidePanel.vue?vue&type=template&id=54fb3680&"
import script from "./SidePanel.jsx?vue&type=script&lang=js&"
export * from "./SidePanel.jsx?vue&type=script&lang=js&"
import style0 from "./SidePanel.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports